(function () {
    var root = (function () { return this; })();
    var app = root.app;
    var overwatch = root.overwatch;

    var iconSelector = '[data-js="horizontal-accordion-icon"]',
        imageSelector = '[data-js="horizontal-accordion-image"]',
        contentSelector = '[data-js="horizontal-accordion-content"]';

    var horizontalAccordion = {
        hoverTimer: null,
        isHovering: false,
        activeItem: null,
        init: function (accordion) {
            var self = this;
            var $columns = self.$columns = $('[data-js="horizontal-accordion-column"]', accordion);
            
            $columns
                .delayedHover(self.hoverColumn, self.hoverColumn, {
                    timeout: 100, self: self
                })
                .each(function (index) {
                    $(this).data('js-index', index);
                });
            
            self.previousColumnIndex = 0;
    
            // init elements that are viewable on page load/refresh
            self.toggleViewable($columns);
            // handle showing when scrolled into view
            $(root).on('scroll.accordion', function () {
                if ($columns.eq(0).hasClass('is-viewable')) {
                    $(root).off('scroll.accordion');
                }
                self.toggleViewable($columns);
            });
        },
        toggleViewable: function(targets) {
            targets.each(function() {
                var $el = $(this);
                // true if elem is in the viewport
                $el.toggleClass('is-viewable', $.isViewable($el));
            });
        },
        hoverColumn: function hoverColumn(event) {
            var self = event.data.self;
            var isEntering = event.type === "delayedEnter";
            var $column = $(this);
            var $icon = $(iconSelector, $column);
            var $image = $(imageSelector, $column);

            if ($column.hasClass("is-open")) { return; }
            $column.toggleClass('is-hover', isEntering);
            $icon.toggleClass("is-hover", isEntering);
            $image.toggleClass("is-hover", isEntering);
            self.isHovering = isEntering;
            if (isEntering) {
                self.prepareToOpenColumn($column);
            }
        },
        prepareToOpenColumn: function prepareToOpenColumn($column) {
            var self = this;
            clearTimeout(this.hoverTimer);
            this.hoverTimer = setTimeout(function () {
                if (self.isHovering) {
                    self.openColumn($column);
                }
            }, 400);
        },
        openColumn: function openColumn($column) {
            var $content = $(contentSelector, $column);
            this.closeAllColumns();
            this.previousColumnIndex = $column.data('js-index');
            $column.toggleClass('is-open', true);
            $content.toggleClass('is-visible', true);

        },
        closeAllColumns: function closeAllColumns() {
            this.$columns.each(function () {
                var $item = $(this);
                var $icon = $(iconSelector, $item);
                var $image = $(imageSelector, $item);
                var $content = $(contentSelector, $item);
                $item.toggleClass('is-open', false);
                $content.toggleClass('is-visible', false);
                $icon.toggleClass("is-hover", false);
                $image.toggleClass("is-hover", false);
            });
        }
    };
    app.horizontalAccordion = horizontalAccordion;
}());
